export default __webpack_public_path__ + "static/media/section3-bg.ce4461d4.png";